<template>
  <p>
    <span v-if="sign">{{sign}}</span>
    {{parseFloat(number).toFixed(2)}} €
  </p>
</template>

<script>
export default {
  props: {
    sign: String,
    number: String,
  },
}
</script>
